const AUTH_AVAILABLE_KEYS = [
  'login',
  'main',
  'parent',
  'person',
  'serviceparent',
  'token',
  'userId',
];


export default {
  _checkKey(name) {
    if (!AUTH_AVAILABLE_KEYS.includes(name)) {
      throw `Unsupported auth key '${ name }'`;
    }
  },

  registerUser(userData) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/register', {
      login: userData.userDetails.login,
      password: userData.userDetails.password,
      password_c: userData.userDetails.password_c,
      nip: userData.userDetails.nip,
      name: userData.userDetails.name,
      surname: userData.userDetails.surname,
      phone: userData.userDetails.phone,
      referer: userData.userDetails.referer,
    });
  },

  loginUser(userData) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/login', {
      login: userData.userDetails.email,
      password: userData.userDetails.password,
    });
  },

  // Re-fetches the login payload for the current bearer token (fresh person/scopes),
  // used to re-bootstrap the session after onboarding re-versions the contractor.
  accessTokens() {
    return axios.post(import.meta.env.VITE_SITE_URL + '/users/access-tokens');
  },

  resetPasswordUser(userData) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/password/reset', {
      token: userData.token,
      login: userData.login,
      password: userData.password,
      password_confirmation: userData.password_confirmation,
    });
  },

  getUser() {
    return axios.get('/api/user',
      { headers: { 'Authorization': 'Bearer ' + this.getToken() } });
  },

  loggedIn() {
    return !!this.getToken();
  },

  setToken(name, token) {
    console.debug('DEPRECATED method `setToken`');
    this.setByKey(name, token);
  },

  setByKey(name, value) {
    this._checkKey(name);
    localStorage.setItem(name, value);
  },

  destroyToken() {
    AUTH_AVAILABLE_KEYS.forEach((key) => {
      localStorage.removeItem(key);
    });
  },

  getByKey(name) {
    this._checkKey(name);
    return localStorage.getItem(name);
  },

  getToken() {
    return this.getByKey('token');
  },


  PROFILE: {
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/profile/' + id);
    },
  },
  USER: {
    updatePassword(id, passwordData) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/users/change-password/' + id, {
        passwordData,
      });
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/users/' + id);
    },
  },
  PERSON: {
    // store(person) {
    //     person = preparePerson(person);
    //     return axios.post(import.meta.env.VITE_SITE_URL + '/persons', {person});
    // },
    update(person) {
      person = preparePerson(person);
      return axios.put(import.meta.env.VITE_SITE_URL + '/persons/' + person.id, { person });
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/' + id);
    },
  },
  BOSS: {
    show() {
      return axios.post(import.meta.env.VITE_SITE_URL + '/persons/get-boss');
    },
  },
  ADDRESS: {
    index() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addresses');
    },
    store(address) {
      address = { ...address };
      let person = JSON.parse(localStorage.getItem('person'));
      address.person = person.id;
      address.country = 1;
      return axios.post(import.meta.env.VITE_SITE_URL + '/persons/addresses', { address: address });
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + id);
    },
    update(address) {
      return axios.put(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + address.id, { address: address });
    },
    destroy(id) {
      return axios.delete(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + id);
    },
  },
  getCountryDictionary() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/persons/country-type/dictionary');
  },
};

function preparePerson(person) {
  person = JSON.parse(JSON.stringify(person));
  if (person.status && person.status.id) {
    person.status = person.status.id;
  }
  person.company.address = person.company.address && person.company.address.id ? person.company.address.id : {};

  return person;
}
